import { render, staticRenderFns } from "./Lahan2.vue?vue&type=template&id=4e0c5575"
import script from "./Lahan2.vue?vue&type=script&lang=js"
export * from "./Lahan2.vue?vue&type=script&lang=js"
import style0 from "./Lahan2.vue?vue&type=style&index=0&id=4e0c5575&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports